import { NgTemplateOutlet } from '@angular/common';
import { Component, input } from '@angular/core';
import { CarouselComponent } from 'src/app/account/components/carousel/carousel.component';
import { BidBoxHeaderComponent } from '../bid-box-header/bid-box-header.component';
import { BidElementComponent } from '../bid-element/bid-element.component';
import { AuctionView } from './../../../articles-manager/interfaces/auction.interface';

@Component({
  selector: 'app-suggested-auctions',
  templateUrl: './suggested-auctions.component.html',
  styleUrls: ['./suggested-auctions.component.scss'],
  standalone: true,
  imports: [
    NgTemplateOutlet,
    BidElementComponent,
    BidBoxHeaderComponent,
    CarouselComponent,
  ],
})
export class SuggestedAuctionsComponent {
  auctionSuggestions = input<AuctionView[]>([]);
  isMemorabid = input<boolean>(true);
}
